import apis from "../../core/apis.js";

class SubscriptionResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.subscription).get(options);
  }

  get(id) {
    return this.$resource(apis.subscription + id).get();
  }

  search(search = "") {
    return this.$resource(apis.subscription).get({ search });
  }

  post(item) {
    return this.$resource(apis.subscription).save(item);
  }

  update(id, item) {
    return this.$resource(apis.subscription + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  delete(id) {
    return this.$resource(apis.subscription + id).delete();
  }

  assign(id, item) {
    return this.$resource(apis.subscription + id + "/assign").save(item);
  }

  unassign(id) {
    return this.$resource(apis.subscription + id + "/unassign").save();
  }
}

export default SubscriptionResource;



// WEBPACK FOOTER //
// ./src/resources/subscription/subscription.resource.js